import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

import {
  Community,
  CommunityStatus,
  nameRules,
} from '@/models/community.model';
import { Municipality } from '@/models/municipality.model';
import { User } from '@/models/user.model';
import { useEvents, Event } from '@/services/events.composable';
import { FilterData } from '@/services/users.service';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import {
  MunicipalitiesActions,
  MunicipalityStoreState,
} from '@/stores/municipalities.store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommunityForm',
  props: {
  data: {
    type: Object as PropType<Community>,
    required: true,
  },
},
  setup(__props) {

const store = useStore<
  ShiftCMSState & { us: UsersState; ms: MunicipalityStoreState }
>();

const events = useEvents();

const filterData = ref<FilterData>({
  search: '',
  level: null,
  page: 1,
  count: 25,
  sort: 'id',
  direction: 'asc',
});

function updateUsers(value: string) {
  filterData.value.search = value;
  store.dispatch(UsersActions.GetUserList, filterData.value);
}

const municipalities = computed<Municipality[]>(
  () => store.state.ms.municipalities,
);

const users = computed<User[]>(() => store.state.us.users);

const props = __props;

const valid = ref<boolean>(false);

const community = ref<Community>({
  ...props.data,
});

const action = computed<string>(() =>
  community.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveCommunity = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (community.value.id === NEW_ID) {
      success = await store.dispatch(
        MunicipalitiesActions.AddCommunity,
        community.value,
      );
    } else {
      success = await store.dispatch(
        MunicipalitiesActions.UpdateCommunity,
        community.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved Community',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(UsersActions.GetCommunitiesList);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save Community',
      type: 'error',
    });
  }
};

onMounted(() => {
  if (props.data) {
    Object.assign(community.value, {
      ...props.data,
    });
  }
  if (props.data.id === NEW_ID) {
    store.dispatch(MunicipalitiesActions.GetMunicipalities);
  }
  if (!props.data.ambassador) {
    // store.dispatch(UsersActions.GetUsers);
  }
});

const deleteCommunity = async () => {
  if (
    community.value &&
    community.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "Community"?')
  ) {
    store.dispatch(MunicipalitiesActions.DeleteCommunity, community.value);

    store.dispatch(UsersActions.GetCommunitiesList);
    store.commit(Mutations.HideDrawer);
  }
};

const communityStatusOptions = [
  {
    title: 'Pending',
    value: CommunityStatus.Pending,
  },
  {
    title: 'Created',
    value: CommunityStatus.Created,
  },
];

const munitipalityName = ref<string>(community.value.municipality?.name || '');
const ambassadorName = ref<string>(
  `${community.value.ambassador?.firstName} ${community.value.ambassador?.lastName}`,
);

const municipalityOptions = computed(() =>
  municipalities.value.map((v) => ({
    title: v.name,
    value: v,
  })),
);
const userOptions = computed(() =>
  users.value
    .filter((u) => !!u.firstName && !!u.lastName)
    .map((v) => ({
      title: `${v.firstName} ${v.lastName} (id: ${v.id})`,
      value: v,
    })),
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveCommunity, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(action.value)) + " a community", 1),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              (community.value.id !== _unref(NEW_ID))
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: community.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((community.value.name) = $event)),
                        rules: _unref(nameRules),
                        label: "Name",
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: community.value.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((community.value.name) = $event)),
                        label: "Name (Automatically Generated)",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              (community.value.id !== _unref(NEW_ID))
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: munitipalityName.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((munitipalityName).value = $event)),
                        label: "Municipality",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: community.value.municipality,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((community.value.municipality) = $event)),
                        label: "Municipality",
                        items: municipalityOptions.value
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })),
              (community.value.id !== _unref(NEW_ID) && __props.data.ambassador)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 2,
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: ambassadorName.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ambassadorName).value = $event)),
                        label: "Ambassador",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_col, {
                    key: 3,
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_autocomplete, {
                        modelValue: community.value.ambassador,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((community.value.ambassador) = $event)),
                        items: userOptions.value,
                        "onUpdate:search": updateUsers,
                        label: "Ambassador"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: community.value.status,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((community.value.status) = $event)),
                    items: communityStatusOptions,
                    label: "Status",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: community.value.groupUrl,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((community.value.groupUrl) = $event)),
                    label: "Signal Group URL",
                    hint: "Set the community status to 'created' when the signal group is ready.",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: community.value.userCount,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((community.value.userCount) = $event)),
                    modelModifiers: { number: true },
                    items: communityStatusOptions,
                    label: "Member count",
                    hint: "Shows how many members this community has",
                    require: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col)
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  (community.value.id !== _unref(NEW_ID))
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "mt-2",
                        type: "button",
                        color: "warning",
                        onClick: deleteCommunity,
                        block: ""
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("Delete")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})